import { FC } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { IStyledAttributes } from "@ryde/shared";

interface IBlueCheckboxCell {
  checked: boolean;
  editableMode?: boolean;
  showConfirm?: boolean;
  confirmMessage?: string;
}

const BlueCheckboxCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "blue-checkbox-cell",
})`
  min-width: 20px;
  display: flex;
  vertical-align: center;
  justify-content: flex-start;
`;

export const BlueCheckboxCell: FC<IBlueCheckboxCell> = ({ checked }) => {
  return (
    <BlueCheckboxCellStyled data-e2e-value={checked ? "checked" : "unchecked"}>
      {checked ? <SVG_MUI.ToggleBlueOnSVG /> : <SVG_MUI.ToggleBlueOffSVG />}
    </BlueCheckboxCellStyled>
  );
};
